import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import Home from '../pages/public/home';

const NotFound = lazy(() => import('../pages/public/notfound'));
const JoinAdditionalSaving = lazy(() => import('../pages/public/join-additional-savings'));
const AccidentInsurance = lazy(() => import('../pages/insurance/accident-insurance'));

const AgentHelpForm = lazy(() => import('../pages/forms/agent-help-form'));
const Agents = lazy(() => import('../pages/agent/agents'));
const CancerDreadDisease = lazy(() => import('../pages/insurance/cancer-dread-disease'));
const CancerHeartStroke = lazy(() => import('../pages/insurance/cancer-heart-stroke'));
const CancerInsuranceWhy = lazy(() => import('../pages/insurance/cancer-insurance-why'));
const Careers = lazy(() => import('../pages/forms/careers'));
const PrivacyStatement = lazy(() => import('../pages/legal/privacy-statement'));
const TermsAndConditions = lazy(() => import('../pages/legal/terms-and-conditions'));

const CreditCounselling = lazy(() => import('../pages/support/credit-counseling'));
const CriticalIllness = lazy(() => import('../pages/insurance/critical-illness'));
const CustomerService = lazy(() => import('../pages/forms/customer-service'));
const DentalDiscount = lazy(() => import('../pages/insurance/dental-discount'));
const DentalInsurance = lazy(() => import('../pages/insurance/dental-insurance'));
const DentalInsuranceWhy = lazy(() => import('../pages/insurance/dental-insurance-why'));
const DentalVisionHearing = lazy(() => import('../pages/insurance/dental-vision-hearing'));
const DisabilityInsurance = lazy(() => import('../pages/insurance/disablity-insurance'));
const GroupPage = lazy(() => import('../pages/support/group-page'));
const Employers = lazy(() => import('../pages/forms/employers'));
const FinalExpense = lazy(() => import('../pages/insurance/final-expense'));
const HomeHealthCare = lazy(() => import('../pages/insurance/home-health-care'));
const IdentifyTheftSolutions = lazy(() => import('../pages/support/identity-theft-solutions'));
const JoinPersonalInfo = lazy(() => import('../pages/public/join-personal-info/index'));
const Unsubscribe = lazy(() => import('../pages/auth/unsubscribe'));
const JoinWelcome = lazy(() => import('../pages/public/join-welcome'));
const LegalServices = lazy(() => import('../pages/support/legal-services'));
const LifeMortgageInsurance = lazy(() => import('../pages/insurance/life-mortgage-insurance'));
const LongTermDisability = lazy(() => import('../pages/insurance/long-term-disability'));
const MedicalGap = lazy(() => import('../pages/insurance/medical-gap'));

const Membership = lazy(() => import('../pages/public/membership'));
const MortgageInsuranceForm = lazy(() => import('../pages/insurance/mortgage-insurance-form'));

const PetInsurance = lazy(() => import('../pages/insurance/pet-insurance'));
const ProductPlans = lazy(() => import('../pages/support/product-plans'));
const Resources = lazy(() => import('../pages/support/resources'));
const ShortTermCare = lazy(() => import('../pages/insurance/short-term-care'));
const ShortTermDisability = lazy(() => import('../pages/insurance/short-term-disability'));
const SignIn = lazy(() => import(/* webpackPrefetch: true */ '../pages/auth/sign-in'));
const Sitemap = lazy(() => import('../pages/legal/sitemap'));
const SocialSharing = lazy(() => import('../pages/support/social-sharing'));
const Strategizer = lazy(() => import('../pages/strategizer/strategizer'));
const StrategizerPayment = lazy(() => import('../pages/strategizer/strategizer-payment'));
const SurityCare = lazy(() => import('../pages/surity-care/surity-care'));
const SurityCareHealthAccessCooperative = lazy(
  () => import('../pages/surity-care/surity-care-health-access-cooperative')
);
const SurityCareHealthAccessPreventive = lazy(
  () => import('../pages/surity-care/surity-care-health-access-preventive')
);
// const SurityCarePaymentOld = lazy(() => import('../pages/surity-care-payment'));
const SurityEssentials = lazy(() => import('../pages/surity-care/surity-essentials'));
const SurityStory = lazy(() => import('../pages/surity-care/surity-story'));
const TaxServices = lazy(() => import('../pages/support/tax-services'));
const UnderConstruction = lazy(() => import('../pages/public/under-construction'));
const ForgotPassword = lazy(() => import('../pages/auth/forgot-password'));

const SharePlan = lazy(() => import('../pages/payments/share-plan'));
// const CareServices = lazy(() => import('../pages/support/care-services'));
const SurityCarePayment = lazy(() => import('../pages/surity-care/surity-care-payment-new'));

const JoinAgent = lazy(() => import('../pages/agent/join-agent'));

const publicRoutes = (
  <>
    <Route path="/" element={<Home />} />
    <Route path="*" element={<NotFound />} />
    {/* <Route path="/join-payment" element={<JoinPayment />} /> */}
    <Route path="/join-additional-savings" element={<JoinAdditionalSaving />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />

    <Route path="/accident-insurance" element={<AccidentInsurance />} />

    <Route path="/agent-help-form" element={<AgentHelpForm />} />
    <Route path="/agents" element={<Agents />} />
    <Route path="/cancer-dread-disease" element={<CancerDreadDisease />} />
    <Route path="/cancer-heart-stroke" element={<CancerHeartStroke />} />
    <Route path="/cancer-insurance-why" element={<CancerInsuranceWhy />} />
    <Route path="/careers" element={<Careers />} />
    <Route path="/privacy-statement" element={<PrivacyStatement />} />
    <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
    <Route path="/credit-counseling" element={<CreditCounselling />} />
    <Route path="/critical-illness" element={<CriticalIllness />} />
    <Route path="/customer-service" element={<CustomerService />} />
    <Route path="/dental-discount" element={<DentalDiscount />} />
    <Route path="/dental-insurance" element={<DentalInsurance />} />
    <Route path="/dental-insurance-why" element={<DentalInsuranceWhy />} />
    <Route path="/dental-vision-hearing" element={<DentalVisionHearing />} />
    <Route path="/disability-insurance" element={<DisabilityInsurance />} />
    <Route path="/employers" element={<Employers />} />
    <Route path="/group-page" element={<GroupPage />} />
    <Route path="/final-expense" element={<FinalExpense />} />
    <Route path="/home-health-care" element={<HomeHealthCare />} />

    <Route path="/identity-theft-solutions" element={<IdentifyTheftSolutions />} />

    <Route path="/join-personal-info" element={<JoinPersonalInfo />} />

    {/* <Route path="/join-personal-info/:id" element={<JoinPersonalInfo />} /> */}

    {/* <Route path="/join/:agent_name/:id" element={<JoinPersonalInfo />} /> */}

    <Route path="/rep/:agent_name/:id" element={<Home />} />

    <Route path="/unsubscribe/:id" element={<Unsubscribe />} />

    <Route path="/join-welcome" element={<JoinWelcome />} />
    <Route path="/legal-services" element={<LegalServices />} />
    <Route path="/life-mortgage-insurance" element={<LifeMortgageInsurance />} />
    <Route path="/long-term-disability" element={<LongTermDisability />} />
    <Route path="/medical-gap" element={<MedicalGap />} />

    <Route path="/membership" element={<Membership />} />
    <Route path="/mortgage-insurance-form" element={<MortgageInsuranceForm />} />

    <Route path="/pet-insurance" element={<PetInsurance />} />
    <Route path="/product-plans" element={<ProductPlans />} />
    <Route path="/resources" element={<Resources />} />
    <Route path="/short-term-care" element={<ShortTermCare />} />
    <Route path="/short-term-disability" element={<ShortTermDisability />} />

    <Route path="/sign-in" element={<SignIn />} />
    <Route path="/sitemap" element={<Sitemap />} />
    <Route path="/social-sharing" element={<SocialSharing />} />
    <Route path="/strategizer" element={<Strategizer />} />
    <Route path="/strategizer-payment" element={<StrategizerPayment />} />
    <Route path="/surity-care" element={<SurityCare />} />
    <Route path="/surity-care-payment" element={<SurityCarePayment />} />
    <Route
      path="/surity-care-health-access-cooperative"
      element={<SurityCareHealthAccessCooperative />}
    />
    <Route
      path="/surity-care-health-access-preventive"
      element={<SurityCareHealthAccessPreventive />}
    />

    <Route path="/surity-essentials" element={<SurityEssentials />} />
    <Route path="/surity-story" element={<SurityStory />} />
    <Route path="/tax-services" element={<TaxServices />} />
    <Route path="/under-construction" element={<UnderConstruction />} />
    <Route path="/share-plan" element={<SharePlan />} />
    {/* <Route path="/care-services" element={<CareServices />} /> */}
    <Route path="/join-agents" element={<JoinAgent />} />

    <Route path="/join/t3s7-x9k2-q1w8" element={<JoinPersonalInfo isTestMode={true} />} />
    <Route path="/agents/d4k8-z2x7-m1p5" element={<Agents isTestMode={true} />} />
  </>
);

export default publicRoutes;
